/*
 * <om-os-tabs> — fanerne på Om os-landingpagen.
 *
 * Hvorfor en web-komponent og ikke bare et <script> i sektionen:
 * Når Shopify gengiver en sektion igen (temaeditoren, og `shopify theme dev`
 * ved hot reload) indsættes HTML'en med innerHTML. Inline-scripts kører IKKE
 * ved den slags indsættelse, så fanerne holdt op med at virke, så snart man
 * rettede en tekst i editoren. Et custom element kobles derimod automatisk på,
 * hver gang elementet indsættes i siden.
 */
if (!customElements.get('om-os-tabs')) {
  customElements.define(
    'om-os-tabs',
    class OmOsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-rr-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-rr-panel]'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.activate(tab.dataset.rrTab, false);
          });

          tab.addEventListener('keydown', (event) => {
            const count = this.tabs.length;
            let next = null;
            if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % count];
            if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + count) % count];
            if (event.key === 'Home') next = this.tabs[0];
            if (event.key === 'End') next = this.tabs[count - 1];
            if (!next) return;
            event.preventDefault();
            this.activate(next.dataset.rrTab, true);
          });
        });
      }

      activate(key, moveFocus) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.rrTab === key;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (selected && moveFocus) tab.focus();
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.rrPanel !== key;
        });
      }
    }
  );
}
